export const locales = {
  en: { common: () => import("./en/common.json") },
};
